import { makeStyles, createStyles, Theme } from 'styles/utils';

export const useStyles = makeStyles((_theme: Theme) => createStyles({
  root: {
    height: '75vh',
    maxHeight: '100%',
  },
}));
